import { Environment } from './types';

/**
 * Exact hostname matches for O(1) lookup.
 */
export const EXACT_HOST_MAP: Readonly<Record<string, Environment>> = {
	localhost: Environment.Development,
	'127.0.0.1': Environment.Development,
	'id.atlassian.com': Environment.Prod,
	'admin.atlassian.com': Environment.Prod,
	'id.stg.internal.atlassian.com': Environment.Staging,
	'admin.stg.atlassian.com': Environment.Staging,
} as const;
